import { useState } from "react";
import { LuEye, LuEyeClosed } from "react-icons/lu";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import methodModel from "../../methods/methods";
import ApiClient from "../../methods/api/apiClient";
import { toast } from "react-toastify";
import loader from "../../methods/loader";
import { logout } from "../../actions/user";

export default function CreateNewPassword() {
  const user = useSelector((state) => state.user);
  console.log(user,"user")
  const history = useNavigate();
  const dispatch = useDispatch();
  const [form, setForm] = useState({
    confirmPassword: "",
    newPassword: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const formValidation = [
    {
      key: "confirmPassword",
      minLength: 8,
      confirmMatch: ["confirmPassword", "newPassword"],
    },
    { key: "newPassword", minLength: 8 },
  ];
  const [eyes, setEyes] = useState({
    password: false,
    confirmPassword: false,
  });

  const inValidNewPassword = methodModel.passwordValidation(form?.newPassword);

  const getError = (key) => {
    return methodModel.getError(key, form, formValidation);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    let invalid = methodModel.getFormError(formValidation, form);
    if (invalid || !inValidNewPassword) return;
    loader(true);
    let payload = {
      id: user?.id || user?._id,
      confirmPassword: form.confirmPassword,
      newPassword: form.newPassword,
    };
    console.log(payload);
    let url = "user/change/user/password";
    ApiClient.put(url, payload).then((res) => {
      if (res.success) {
        toast.success(res.message);
        history("/products");
      }
      loader(false);
    });
  };

  return (
    <>
      <div
        className="h-screen overflow-auto flex !bg-bottom !bg-cover !bg-no-repeat p-5"
        style={{ background: "url('assets/img/auth-bg.webp')" }}
      >
        <div className="w-full m-auto">
          <div className="auth-page grid grid-cols-12 gap-3 max-w-[500px] md:max-w-[900px] w-full rounded-[20px] bg-white sm:px-10 p-5 py-10 mx-auto relative">
            <div className="col-span-5 max-md:hidden">
              <div className="flex flex-col gap-y-[6rem] justify-between h-full">
                {/* <Link to="/"> */}
                  <img
                    src="/assets/img/logo.png"
                    class="w-[120px] md:w-[120px] object-contain mx-auto"
                  />
                {/* </Link> */}
                <div className="relative top-[10px]">
                  <img
                    src="/assets/img/auth-left-img.png"
                    className="w-full h-full object-contain scale-[1.6]"
                  />
                </div>
              </div>
            </div>
            <div className="col-span-12 md:col-span-7 flex h-full items-center md:ml-[4rem] z-10">
              <form onSubmit={(e) => handleSubmit(e)} className="w-full">
                <div className="space-y-3">
                  <img
                    src="/assets/img/circle-2.png"
                    className="w-125px h-[125px] object-contain absolute right-5 top-0"
                  />
                  <img
                    src="/assets/img/logo.png"
                    class="w-[120px] md:w-[120px] object-contain cursor-pointer mx-auto md:hidden"
                  />
                  <div className="space-y-1">
                    <h3 className="text-2xl text-[#414141] text-center font-semibold">
                      Set Your Password
                    </h3>
                    <p className="text-sm text-center text-[#737373]">
                      A temporary password has been sent to your email. Please
                      create a new password to continue using your account.
                    </p>
                  </div>
                </div>
                <div className="space-y-4 mt-7">
                  <div className="w-full space-y-1">
                    <label className="text-sm font-[400] text-[#737373]">
                      New Password
                    </label>
                    <div className="relative">
                      <input
                        type={eyes.password ? "text" : "password"}
                        value={form.newPassword}
                        minLength={8}
                        maxLength={16}
                        onChange={(e) =>
                          setForm({
                            ...form,
                            newPassword: e.target.value,
                          })
                        }
                        required
                        className="border !outline-none h-11 rounded-[12px] w-full text-[12px] pl-4 pr-[44px]"
                      />
                      {!eyes?.password ? (
                        <LuEyeClosed
                          onClick={() =>
                            setEyes({
                              ...eyes,
                              password: !eyes.password,
                            })
                          }
                          className="text-[#737373] absolute top-[0px] right-[0px] w-[44px] h-[44px] p-[12px] cursor-pointer hover:opacity-70"
                        />
                      ) : (
                        <LuEye
                          onClick={() =>
                            setEyes({
                              ...eyes,
                              password: !eyes.password,
                            })
                          }
                          className="text-[#737373] absolute top-[0px] right-[0px] w-[44px] h-[44px] p-[12px] cursor-pointer hover:opacity-70"
                        />
                      )}
                      {form?.newPassword &&
                        !inValidNewPassword &&
                        submitted && (
                          <span role="alert" className="text-[#c53030] text-xs mt-1 block">
                            {methodModel.passwordValidationMessages(
                              form?.newPassword,
                            )}
                          </span>
                        )}
                    </div>
                  </div>
                  <div className="w-full space-y-1">
                    <label className="text-sm font-[400] text-[#737373]">
                      Confirm New Password
                    </label>
                    <div className="relative">
                      <input
                        type={eyes.confirmPassword ? "text" : "password"}
                        value={form.confirmPassword}
                        minLength={8}
                        maxLength={16}
                        onChange={(e) =>
                          setForm({
                            ...form,
                            confirmPassword: e.target.value,
                          })
                        }
                        required
                        className="border !outline-none h-11 rounded-[12px] w-full text-[12px] pl-4 pr-[44px]"
                      />
                      {!eyes?.confirmPassword ? (
                        <LuEyeClosed
                          onClick={() =>
                            setEyes({
                              ...eyes,
                              confirmPassword: !eyes.confirmPassword,
                            })
                          }
                          className="text-[#737373] absolute top-[0px] right-[0px] w-[44px] h-[44px] p-[12px] cursor-pointer hover:opacity-70"
                        />
                      ) : (
                        <LuEye
                          onClick={() =>
                            setEyes({
                              ...eyes,
                              confirmPassword: !eyes.confirmPassword,
                            })
                          }
                          className="text-[#737373] absolute top-[0px] right-[0px] w-[44px] h-[44px] p-[12px] cursor-pointer hover:opacity-70"
                        />
                      )}
                      {submitted && getError("confirmPassword").invalid ? (
                        <>
                          {getError("confirmPassword").err.confirmMatch ? (
                            <span role="alert" className="d-block text-[#c53030] text-xs mt-1 block">
                              Confirm Password is not matched with New Password
                            </span>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>

                <div className="flex gap-5 justify-between mt-8">
                  {/* <Link
                    to="/profile"
                    className="bg-white w-full text-sm font-[600] text-gray-600 border h-11 flex items-center justify-center gap-2 rounded-[12px] shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed !px-4"
                  >
                    Back
                  </Link> */}
                  <button
                    type="submit"
                    className="bg-[linear-gradient(45deg,#115B9D,#062037)] w-full text-sm font-[600] text-white h-11 flex items-center justify-center gap-2 rounded-[12px] shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed !px-4"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
